<template>
  <ticket
    :tickets="tickets"
    :start-print="startPrint"
    :solde="solde"
    :html="html"
    :left-to-pay="leftToPay"
    :carrier="carrier"
    :for-merchant="forMerchant"
    :signature="signature"
    :reference="reference"
    :id-badge="idBadge"
    :floating-mode-enabled="floatingModeEnabled"
  />
</template>

<script>
import Ticket from '../components/Ticket'

export default {
  name: 'TicketView',

  components: {
    Ticket
  },

  props: {
    tickets: { type: Array, default: null },
    startPrint: { type: Boolean, default: false },
    solde: { type: String, default: '' },
    html: { type: String, default: null },
    leftToPay: { type: Number, default: 0 },
    carrier: { type: Object, default: null },
    forMerchant: { type: Boolean, default: false },
    floatingModeEnabled: { type: Boolean, default: false },
    signature: { type: Boolean, default: false },
    reference: { type: String, default: null },
    idBadge: { type: String, default: null },
  },

  beforeMount () {
    this.$emit('title', this.$i18n.t('title.ticket'))
  }
}
</script>
